import React, { useContext, useEffect } from 'react';
import { TheAppContext } from 'provider/AppContext';
import { Box, Dialog } from '@mui/material';
const LightBox = () => {
  const { boxShowing, setBoxShowing } = useContext(TheAppContext);

  const handleClickOff = (e) => {
    if (boxShowing.visible && e.target.id === 'wrap') {
      clearBox();
    }
  };

  const clearBox = () => {
    setBoxShowing({ visible: false, component: null });
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOff);
    return () => document.removeEventListener('click', handleClickOff, false);
  }, [boxShowing.visible]);

  // if (!boxShowing.visible) return <></>;

  return (
    <Dialog
      open={boxShowing.visible}
      onClose={clearBox}
      maxWidth="sm"
      fullWidth
    >
      <Box>{boxShowing.component}</Box>
    </Dialog>
  );
};

export default LightBox;
